<template>
  <div v-wechat-title="this.helpOrCustomer" class="helpCenter">
    <!--公共头部 -->
    <com-header :message="message"></com-header>

    <!-- 中间内容区 -->
    <div class="helpCenter_container">
      <!-- 头部banner搜索区 -->
      <div class="helpCenter_top">
        <img src="../../assets/images/Help.png" alt />

        <div class="search">
          <input
            v-model="searchWord"
            type="text"
            :placeholder="placeholder"
            @focus="placeholder = ''"
            @blur="placeholder = '搜索您的问题或关键词'"
            @keyup.enter="ent"
          />
          <div class="search_img hoverCurser" @click="searchE">
            <img src="../../assets/images/seacrch_icon.png" />
          </div>
        </div>
      </div>

      <!-- 一级频道 -->

      <div v-loading="channelListLoading" class="channelList bg_fff overflow_h">
        <div
          v-for="(item, index) in channelList"
          :key="index"
          class="channel_item fl hoverCurser"
          @click="checkChannel(index, item.pagetypeName, item.id)"
        >
          <div class="imgWrap">
            <img
              :src="
                checkedIndex === index ? item.pagetypeIcon1 : item.pagetypeIcon
              "
              alt
            />
          </div>
          <p
            class="fl"
            :style="{ color: checkedIndex === index ? '#FC6D6D' : '#333333' }"
          >
            {{ item.pagetypeName }}
          </p>
        </div>
      </div>

      <div class="helpCenter_middle">
        <div class="middleWrap">
          <!-- 左边导航栏 :class="chooseStyle == treeData.id? 'chooseNode' : ''"
          :default-checked-keys="defaultChecked"
          -->
          <div class="middle_left fl">
            <h1>{{ moddleColumn }}</h1>
            <div style="height:680px">
              <el-scrollbar
                ref="scrollWrap"
                v-loading="treeLoading"
                style="height:100%;"
              >
                <el-tree
                  ref="viewTree"
                  :data="treeData"
                  node-key="id"
                  :props="defaultProps"
                  :default-expanded-keys="defaultOpen"
                  :current-node-key="defaultChecked"
                  :highlight-current="true"
                  @node-click="handleNodeClick"
                ></el-tree>
              </el-scrollbar>
              <!-- :class="initStyle" -->
            </div>
          </div>

          <!-- 右边显示搜索区 -->
          <div class="middle_right fl">
            <div v-if="titleShow" class="title_stratum font12">
              <span v-html="floorTitle">{{ floorTitle }}</span>
            </div>
            <div v-if="!titleShow" class="search_text">
              搜索{{ `"${keyWord}"` }}
            </div>

            <!-- 搜索列表显示区 -->
            <div v-if="listShow" class="substance_wrap">
              <div
                v-if="
                  searchData.length == undefined ||
                    searchData.length == null ||
                    searchData.length < 1
                "
              >
                暂无数据
              </div>
              <div
                v-for="(item, index) in searchData"
                :key="index"
                class="substance hoverCurser"
                @click="showArticleDetail(item)"
              >
                <div class="substance_title font16">
                  {{ item.pageName }}
                </div>
                <div class="editTime marginL_46 font14">
                  {{ item.addTime }}
                </div>
                <p class="marginL_46 font14" v-html="item.notes">
                  {{ item.notes }}
                </p>
              </div>
            </div>

            <!-- 分页器 -->
            <div v-if="pagingDevice && listShow" class="infoContent_paging">
              <el-pagination
                background
                layout="prev, pager, next,total,jumper,sizes"
                :total="totalNewsNums"
                :accordion="true"
                :current-page="currentPageNum"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pageSizeActive"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                @prev-click="handlePrevPage"
                @next-click="handleNextPage"
              ></el-pagination>
            </div>

            <!-- 内容详情显示区 -->
            <div
              v-if="!listShow"
              v-loading="articleDetailLoading"
              class="articleDetails"
            >
              <!-- <h1 class="fontW tCenter">{{headline}}</h1> -->
              <div class="font14" v-html="content">
                {{ content }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <com-footer v-if="footShow"></com-footer>
  </div>
</template>
<script>
// 引入防抖方法
import { _debounce } from '../../util/public'
import NProgress from 'nprogress'
export default {
  data() {
    return {
      // 页面标题
      helpOrCustomer: '',
      moddleColumn: '帮助中心',
      message: '',
      footShow: true,
      bannerUrl: '',
      // input框输入
      searchWord: '',
      placeholder: '搜索您的问题或关键词',
      treeData: [],
      // 动态添加tree选中样式
      chooseStyle: '',
      defaultProps: {
        children: 'threeChild',
        label: 'pageName'
      },
      treeLoading: true,
      // 默认展开节点
      defaultOpen: [],
      // 默认选中节点
      defaultChecked: '',
      // 搜索关键字
      keyWord: '管理',
      titleShow: true,
      // 搜索展示列表
      searchData: [],
      listShow: false,
      // 详情页内容
      headline: '',
      content: '构新城平台，所有的网站及相关移动应用，是管理、采购与供应',
      // 分页器
      pagingDevice: true,
      totalNewsNums: '',
      pageSizeActive: 10,
      currentPageNum: 1,
      chooseLiNum: 0,
      // 右侧菜单层级显示
      floorTitle: '',
      checkedIndex: 0,
      // 频道列表
      channelList: [],
      channelListLoading: true,
      articleDetailLoading: true
    }
  },
  created() {
    this.helpOrCustomer = `智筑通 - ${this.$route.query.judgeKey}`
    //  this.moddleColumn = this.$route.query.judgeKey
    this.message = this.$route.query.judgeKey
    // 重置分页列表数据
    this.resetPage()
    // 获取一级菜单
    this.getMenu('init')
  },
  methods: {
    openWindow() {
      let routerData = this.$router.resolve({
        name: 'businessWindow'
      })
      let url = routerData.href
      window.open(
        url,
        '_blank',
        'resizable=yes, scrollbars=no, left=10, top=10, toolbar=no, status=no, menubar=no, Width = 1220, height=810'
      )
    },
    // pageSize每页条数改变时会触发
    handleSizeChange(val) {
      this.pageSizeActive = val
      this.searchList()
    },
    // 点击next时触发
    handleNextPage(val) {
      this.currentPageNum = val
      this.searchList()
    },
    // 点击prev时触发
    handlePrevPage(val) {
      this.currentPageNum = val
      this.searchList()
    },
    // currentPage 当前页改变时会触发
    handleCurrentChange(val) {
      this.currentPageNum = val
      this.searchList()
    },
    // 重置
    resetPage() {
      this.currentPageNum = 1
      this.pageSizeActive = 10
      this.chooseLiNum = 0
      this.chooseStyle = ''
      this.defaultOpen = []
      this.$nextTick(function() {
        this.$refs.viewTree.setCurrentKey('')
      })
    },
    // 查询一级菜单
    getMenu(a) {
      this.$http.get('/cms/ptPageType/getNodes').then(res => {
        if (res.data.code === '000000') {
          this.channelList = res.data.result
          if (this.channelList.length > 0) {
            this.moddleColumn = this.channelList[0].pagetypeName
            // 根据一级菜单查询二三级
            this.init(this.channelList[0].id, a)
          }
          this.channelListLoading = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    async init(id, a) {
      this.treeData = []
      // 查询父节点以及页面分类图片
      await this.$http
        .get('/cms/ptPage/findPtPageNodeList/' + id)
        .then(res => {
          if (res.data.code === '000000') {
            this.treeData = res.data.result[0].ptPage
            if (this.treeData.length === 0) {
              this.articleDetailLoading = 0
            }
            // 判断是否是初始化进入页面
            if (a === 'init') {
              // 默认展开第一个第二级
              this.defaultOpen.push(this.treeData[0].id)
              // 默认选中第一个第二级的第一个第三级
              this.defaultChecked = this.treeData[0].threeChild[0].id
              // 设置选中的子节点的颜色
              this.$nextTick(() => {
                this.$refs.viewTree.setCurrentKey(
                  this.treeData[0].threeChild[0].id
                )
              })

              this.chooseStyle = this.treeData[0].threeChild[0].id
              console.log(this.defaultChecked)
              // 调用此方法展示右侧内容
              this.handleNodeClick(
                this.treeData[0].threeChild[0],
                'init',
                this.treeData[0].pageName
              )
            }

            this.treeLoading = false
          } else {
            this.treeLoading = false
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          if (err) {
            this.treeLoading = false
            NProgress.done()
            this.content = '暂无数据'
          }
        })
    },
    // 处理叶子节点函数
    async getSecondLayer(getData) {
      if (getData.length > 0) {
        // 根据主键菜单查询二级菜单
        for (let i = 0; i < getData.length; i++) {
          // 根据主键菜单查询二级菜单
          this.$http
            .get('/cms/ptPage/' + `${getData[i].id}`)
            .then(res => {
              var secondData = res.data.content
              // var title = `<span>${getData[i].label}&nbsp;&gt;&nbsp;</span><span class='color_d21'>${secondData[0].pageName}</span>`
              if (secondData.length > 0) {
                secondData.forEach(item => {
                  getData[i].children.push({
                    id: item.id,
                    label: item.pageName,
                    notes: item.notes,
                    addTime: item.addTime,
                    isLeaf: item.isLeaf,
                    children: []
                  })
                })
              } // 加一个当前list没有子节点的逻辑
              this.treeData = getData
            })
            .catch(err => {
              if (err) {
                NProgress.done()
                console.log('查询二级菜单接口错误')
                //  this.content = '暂无数据'
              }
            })
        }
      }
    },
    searchE() {
      if (this.searchWord !== '') {
        // 重置分页列表数据
        this.resetPage()
        this.searchList()
      } else {
        this.$message.error('搜索条件不能为空!')
      }
    },
    // 一级频道点击事件
    checkChannel(index, txt, id) {
      this.checkedIndex = index
      this.moddleColumn = txt
      // 查询二三级菜单
      this.init(id, 'init')
      this.treeLoading = true
      this.defaultOpen = []
    },
    // enter事件
    ent() {
      if (this.searchWord !== '') {
        // 重置分页列表数据
        this.resetPage()
        this.searchList()
      } else {
        this.$message.error('搜索条件不能为空!')
      }
    },
    // 列表点击事件
    showArticleDetail(item) {
      this.defaultOpen = []
      this.titleShow = true
      this.floorTitle = `<span class='color_d21'>${item.pageName}</span`
      this.listShow = false
      this.content = item.notes
      this.defaultOpen.push(item.id)
      this.chooseStyle = item.id
      this.$nextTick(function() {
        this.$refs.viewTree.setCurrentKey(item.id)
      })
    },
    // 搜索框focus事件
    searchInfo() {
      this.placeholder = ''
    },
    // 搜索
    async searchList() {
      this.keyWord = this.searchWord
      // {pageName}/{page}/{size}模糊查询
      let page = this.currentPageNum - 1

      this.$http
        .get(
          '/cms/ptPage/findByPageNameLike/' +
            `${this.searchWord}/${page}/${this.pageSizeActive}`
        )
        .then(res => {
          // 搜索显示
          this.titleShow = false
          // 列表显示
          this.listShow = true

          // 数据渲染
          if (res.data.totalElements > this.pageSizeActive) {
            this.pagingDevice = true
            this.totalNewsNums = res.data.totalElements
          } else {
            this.pagingDevice = false
          }
          this.searchData = res.data.content
        })
        .catch(err => {
          if (err) {
            NProgress.done()
            this.searchData = []
            // 搜索显示
            this.titleShow = false
            this.listShow = true
            this.pagingDevice = false
            console.log('搜索接口500')
          }
        })
    },
    // 帮助中心菜单点击事件
    handleNodeClick: _debounce(function(val, node, c) {
      // 搜索显示
      this.titleShow = true
      // 列表显示
      this.listShow = false

      if (node === 'init') {
        let content = `<span>${c}&nbsp;&gt;&nbsp;</span><span class='color_d21'>${val.pageName}</span>`
        this.floorTitle = content
      } else {
        let a = ''
        a = node.level
        // 点击左侧菜单查询右侧菜单显示内容
        switch (a) {
          case 1:
            // this.floorTitle = `<span class='color_d21'>${val.pageName}</span>`
            let content1 = `<span>${val.pageName}&nbsp;&gt;&nbsp;</span><span class='color_d21'>${val.threeChild[0].pageName}</span>`
            this.floorTitle = content1
            // 设置选中的子节点的颜色
            this.$nextTick(() => {
              this.$refs.viewTree.setCurrentKey(
                val.threeChild[0].id
                // this.treeData[0].threeChild[0].id
              )
            })
            break
          case 2:
            let content = `<span>${node.parent.data.pageName}&nbsp;&gt;&nbsp;</span><span class='color_d21'>${val.pageName}</span>`
            this.floorTitle = content
            break
        }
      }

      // 右侧文本内容
      this.listShow = false
      this.headline = val.pageName
      if (val.notes !== '') {
        this.content = val.notes
      } else {
        if (node.level === 1 && val.threeChild[0].notes !== '') {
          this.content = val.threeChild[0].notes
        } else {
          this.content = '暂无数据'
        }
      }
      this.articleDetailLoading = false
    }, 200)
  }
}
</script>
<style lang="scss" scope>
@import './HelpCenter.scss';
</style>
